import { useCallback, useEffect, useState } from 'react'

import window from 'browser-lib/window'

import { fetchCollege } from 'common/load-college-with-content'

const FIELDS = [
  'details',
  'affiliateColleges',
  'location',
  'studentLife',
  'academics',
  'admissions',
  'financials',
  'map',
  'athletics',
]

const AFFILIATE_FIELDS = ['details', 'financials', 'content']

const useLoadCollegeOnMount = (scid) => {
  const [response, setResponse] = useState({})
  const [loading, setLoading] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const getCollege = useCallback(() => {
    setLoading(true)
    setLoaded(false)
    fetchCollege(scid, FIELDS, AFFILIATE_FIELDS)
      .then((response) => {
        setResponse(response)
        setLoading(false)
        setLoaded(true)
      })
      .catch((response) => {
        const { status } = response
        if (status < 500 && status > 399) {
          window.location.href = import.meta.env.BASE_URL + '/four-oh-four'
        }
        setLoading(false)
        setLoaded(true)
      })
  }, [scid])

  useEffect(() => {
    getCollege()
  }, [getCollege])

  return {
    college: response,
    loading,
    loaded,
    getCollege,
  }
}

export default useLoadCollegeOnMount
